import { Routes, Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import RootLayout from '@layouts/RootLayout';
import PageLoader from '@components/ui/PageLoader';
import { AuthProvider } from '@contexts/AuthContext';
import { AuthGateProvider } from '@contexts/AuthGateContext';
import { ToastProvider } from '@contexts/ToastContext';
import ProtectedRoute from '@components/auth/ProtectedRoute';

// Lazy load pages for code splitting
const HomePage = lazy(() => import('@pages/HomePage'));
const InvestorPortalPage = lazy(() => import('@pages/InvestorPortalPage'));
const DashboardPage = lazy(() => import('@pages/DashboardPage'));
const AuthPage = lazy(() => import('@pages/AuthPage'));
const ForgotPasswordPage = lazy(() => import('@pages/ForgotPasswordPage'));
const NotFoundPage = lazy(() => import('@pages/NotFoundPage'));

export default function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <AuthGateProvider>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              {/* Full-screen auth pages — outside the marketing layout */}
              <Route path="/login" element={<AuthPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />

              {/* Everything else renders inside the marketing shell */}
              <Route
                path="/*"
                element={
                  <RootLayout>
                    <Routes>
                      {/* Public landing page */}
                      <Route path="/" element={<HomePage />} />

                      {/* Investor Portal — public by design, no auth gate */}
                      <Route path="/investor-portal" element={<InvestorPortalPage />} />

                      {/* Protected — requires an authenticated account */}
                      <Route
                        path="/dashboard"
                        element={
                          <ProtectedRoute>
                            <DashboardPage />
                          </ProtectedRoute>
                        }
                      />

                      <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                  </RootLayout>
                }
              />
            </Routes>
          </Suspense>
        </AuthGateProvider>
      </ToastProvider>
    </AuthProvider>
  );
}
